module.exports = __webpack_public_path__ + "media/svg/horizontal-dots-3f3b97fa.svg";